import React, { useContext } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import moment from "moment";
import Constant from "../Constants";

const OrderTable = ({
  data,
  columnsVisibility,
  setColumnSorts,
  columnSorts,
}) => {
  const { t } = useContext(LanguageContext);
  const { productType, ordersStatus, placementItems } = Constant();

  const setColumnSort = (columnIndex) => {
    setColumnSorts((prevSorts) => ({
      ...prevSorts,
      [columnIndex]:
        prevSorts[columnIndex] === "asc"
          ? "desc"
          : prevSorts[columnIndex] === "desc"
          ? null
          : "asc",
    }));
  };

  const columnsHeader = [
    { key: "order", label: t("Order"), isSortable: true, sortId: 0 },
    { key: "product", label: t("Product"), isSortable: true, sortId: 1 },
    { key: "contracts", label: t("Contracts"), isSortable: false },
    { key: "status", label: t("Status"), isSortable: true, sortId: 2 },
    { key: "amount", label: t("Amount"), isSortable: true, sortId: 3 },
    { key: "date", label: t("Date"), isSortable: true, sortId: 4 },
  ];

  const contractsList = (contract) => {
    const groupedContracts = contract?.reduce((acc, item) => {
      const { type } = item;
      if (!acc[type]) {
        acc[type] = { count: 0, label: placementItems[type] };
      }
      acc[type].count++;
      return acc;
    }, {});

    return (
      <>
        {Object.keys(groupedContracts)?.map((type, index) => {
          const { count, label } = groupedContracts[type];
          return (
            <span
              key={index}
              className="text-secondary bg-soft-secondary border-radius-5px d-flex justify-content-center align-items-center text-center m-2"
              style={{
                minWidth: "auto",
                height: "29px",
                padding: "0 18px",
              }}
            >
              {count} - {label}
            </span>
          );
        })}
      </>
    );
  };

  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const columnHeaderValue = {
    order: {
      value: (item) => item?.code,
      className: () => `text-dark`,
      style: { fontSize: "16px" },
    },
    product: {
      value: (item) => productType[item?.product],
      className: () =>
        `text-secondary bg-soft-secondary border-radius-5px d-flex justify-content-center align-items-center text-center`,
      style: { width: "116px", height: "29px" , maxWidth: "auto"},
    },
    contracts: {
      value: (item) => (
        <span className="d-flex justify-content-center gap-2">
          {contractsList(item?.items)}
        </span>
      ),
      style: {
        fontSize: "14px",
        fontWeight: "600",
      },
    },
    status: {
      value: (item) => ordersStatus[item?.status]?.title,
      className: (item) =>
        `${
          ordersStatus[item?.status]?.class
        } border-radius-5px d-flex justify-content-center align-items-center  text-center`,
      style: { width: "95px", height: "29px" ,maxWidth: "auto"},
    },
    amount: {
      value: (item) => `$${formatNumberWithCommas(item?.amount) ?? "0"}`,
      className: () => "w-100 text-dark",
      style: { fontSize: "16px" },
    },
    date: {
      value: (item) =>
        `${t(moment(item?.created).format("MMM"))} ${moment(
          item?.created
        ).format("DD, h:mm")} ${t(moment(item?.created).format("A"))}`,
      className: () => "w-100 text-dark",
      style: { fontSize: "16px", fontWeight: "300" },
    },
  };

  return (
    <div className="table-responsive datatable-custom">
      <table
        id="datatable"
        className="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
      >
        <thead className="thead-light">
          <tr>
            {columnsHeader.map(({ key, label, isSortable, sortId }) =>
              columnsVisibility[key] ? (
                <th
                  key={key}
                  className={`${isSortable ? "sorting" : ""}${
                    isSortable && !columnSorts[sortId]
                      ? ""
                      : columnSorts[sortId] === "asc"
                      ? "_asc"
                      : "_desc"
                  }`}
                  onClick={() => (isSortable ? setColumnSort(sortId) : {})}
                  style={{
                    minWidth: key === "contracts" && "400px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t(label)}
                </th>
              ) : null
            )}
          </tr>
        </thead>
        <tbody
          id="nav-one-eg1"
          aria-labelledby="nav-one-eg1-tab"
          className="table-row-main"
        >
          {!!data?.length ? (
            data.map((item, index) => (
              <tr key={index}>
                {Object.entries(columnsVisibility)?.map(
                  ([key, isVisible]) =>
                    isVisible && (
                      <td key={key}>
                        <span
                          style={{
                            ...columnHeaderValue[key]?.style,
                            display: "inline-block",
                          }}
                          className={`${columnHeaderValue[key]?.className?.(
                            item
                          )}`}
                        >
                          {columnHeaderValue[key]?.value(item)}
                        </span>
                      </td>
                    )
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="100%">
                <div className="text-center p-4 no-data-wrapper">
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="dark"
                  />
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="default"
                  />
                  <p className="mb-0">
                    {!data ? t("Loading data") : t("No data to show")}
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OrderTable;
